var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('VuetifyAudio',{attrs:{"file":_vm.audioURL,"color":"primary","downloadable":"","autoPlay":"","flat":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }